// components/OptimizedImage.jsx
import React from "react";

/**
 * Optimized Image component with lazy loading and better performance
 *
 * @param {string} src - Image source
 * @param {string} alt - Alt text for accessibility
 * @param {string} className - CSS class name
 * @param {boolean} eager - If true, loads immediately (for above-fold images)
 * @param {number} width - Intrinsic width (helps prevent layout shift)
 * @param {number} height - Intrinsic height (helps prevent layout shift)
 * @param {object} ...props - Other img attributes
 */
const OptimizedImage = ({
  src,
  alt,
  className = "",
  eager = false,
  width,
  height,
  ...props
}) => {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      width={width}
      height={height}
      {...props}
    />
  );
};

export default OptimizedImage;
